module.exports = require('./dist/lib/head')



//////////////////
// WEBPACK FOOTER
// ../.semaphore-cache/solaris-frontend/node_modules/next/head.js
// module id = 1005
// module chunks = 19